<template>
    <div>
      <section class="container container--fluid section is-main-section">
        <form @submit.prevent="save">
          <div>

            <v-card-component :title="cardTitle">
              <v-card-actions>

                <router-link v-if="isVendorActivated" :to="{ name: 'VendorEdit' }">
                  <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
                    <v-icon left>mdi-pencil</v-icon>Edit
                  </v-btn>
                </router-link>
                <router-link v-else :to="{ name: 'Vendor' }">
                  <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
                    <v-icon left>mdi-arrow-left</v-icon>Back
                  </v-btn>
                </router-link>
              </v-card-actions>
              <v-row
              class="read-only-container "
              >
                <v-col>
                  <v-row>
                    <v-col cols="12" lg="4" sm="6">
                      <span class="body-2 font-weight-medium" >1.Select Franchise</span>
                      <span class="error--text ml-1">*</span>:
                      <v-autocomplete v-model="formData.franchiseeID" key="id" class="my-0 py-1" required single-line placeholder="---Select---" :items="franchiseeArr" item-text="companyName" item-value="id">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="4" sm="6">
                      <span class="body-2 font-weight-medium" >2.Owned By</span>
                      <span class="error--text ml-1">*</span>:
                      <v-autocomplete v-model="formData.ownedBy" key="id" class="my-0 py-1" required single-line placeholder="---Select---" :items="VehicleTypes" item-text="name" item-value="value">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="4" sm="6">
                      <span class="body-2 font-weight-medium">3.Owner Name</span>
                      <span class="error--text ml-1">*</span>:
                      <v-text-field v-model.trim="formData.ownerName" required class="my-0 py-1">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" sm="6">
                      <span class="body-2 font-weight-medium">4.Owner's Mobile No. 21</span>
                      <span class="error--text ml-1">*</span>:
                      <v-text-field v-model="formData.ownersMobileNumber" required class="my-0 py-1" type="tel" maxlength="10"  placeholder="Enter 10-digit mobile number">
                        <!-- <template v-slot:append>
                          <v-btn
                            icon
                            color="primary"
                            @click="verifyMobileNo"
                          >
                          verify
                          </v-btn>
                        </template> -->
                        <template v-slot:append>
                          <v-icon color="#00ff00">mdi-check-decagram-outline</v-icon>
                        </template>
                      </v-text-field>

                    </v-col>
                    <v-col cols="12" lg="4" sm="6">
                      <span class="body-2 font-weight-medium">5.Number of Vehicles</span>
                      <span class="error--text ml-1">*</span>:
                      <v-text-field v-model="formData.numberOfVehicle" required class="my-0 py-1" type="number" min="1">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" sm="6">
                      <span class="body-2 font-weight-medium">6.Number of Drivers</span>
                      <span class="error--text ml-1">*</span>:
                      <v-text-field v-model="formData.numberOfDrivers" required class="my-0 py-1" type="number" min="1">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-container
              class="read-only-container container--fluid"
              >
                <v-card class="cardviewborder"
                v-for="(bus, index) in formData.buses" :key="index"
                >
               <v-toolbar flat>
                  <v-toolbar-title class="text-h6">{{ `Section B.${index + 1}. Vehicle ${index + 1}` }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <h6>{{`updated: ${formData.updatedAt}`}}</h6>
               </v-toolbar>
               <v-card-text>
                <div class="mt-2">
                <v-row>
                  <v-col>
                    <v-row>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">1.Vehicle Registration No.</span>
                        <span class="error--text ml-1">*</span>:
                        <v-text-field v-model.trim="bus.vehicleRegistrationNumber" required class="my-0 py-1"  @input="handleVehicleNumberInput($event, index)"></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium" >2.Seating Capacity</span>
                        <small class="text-muted">(This is excluding Driver & Bus Attendant)</small>
                        <span class="error--text ml-1">*</span>:<br/>

                        <v-text-field v-model="bus.seatingCapacity" required class="my-0 py-1" type="number" min="0"  ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">3.Make of the Vehicle</span>
                        <span class="error--text ml-1">*</span>:
                        <v-text-field v-model.trim="bus.makeOfVehicle" required class="my-0 py-1"  ></v-text-field>
                      </v-col>

                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-row>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">4.Model of the Vehicle</span>
                        <span class="error--text ml-1">*</span>:
                        <v-text-field v-model.trim="bus.modelOfVehicle" required class="my-0 py-1"  ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" sm="6" class="custompointer">
                        <span class="body-2 font-weight-medium">
                        5. RC Expiry Date
                        <span class="error--text ml-1">*</span>:
                        <v-tooltip  v-if="bus.rcExpiryDetails.isExpired" bottom
                        color="#E65050"
                        >
                          <template v-slot:activator="{ on, attrs }">
                             <v-icon class="ml-5" v-bind="attrs" v-on="on" color="red">mdi-information</v-icon>
                          </template>
                          <span
                          class="red-tooltip"
                           >
                          {{ bus.rcExpiryDetails.sentence }}
                          </span>
                        </v-tooltip>
                      </span>
                        <custom-date-picker v-model="bus.rcBookExpiryDate" @input="handleValidateExpiryDate($event,'RC', 'buses', 'rcBookExpiryDate', index)"/>
                      </v-col>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">6.PUC Expiry Date</span><span class="error--text ml-1">*</span>:
                        <custom-date-picker v-model="bus.pucExpiryDate"  @input="handleValidateExpiryDate($event,'PUC','buses','pucExpiryDate',index)"/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <p>Uploaded Documents:</p>
                    <v-row v-if="bus.busID">
                      <v-col v-for="(document,index) in bus.transportVendorBusesDocuments" :key="document.busDocumentID" cols="12" sm="6" md="4">

                        <v-card class="relative-position allviewpadd" v-if="document && document.urlPath">
                          <h4>{{ `${index + 7}.${photoFieldNames[document.photoField] || formatCamelCase(document.photoField)}` }}<span class="error--text ml-1">*</span>:</label></h4>
                          <div
                            @click="handleImageClick(document)"
                            style="cursor: pointer; height: 200px; display: flex; align-items: center; justify-content: center;"
                          >
                            <v-img
                              :src="document.urlPath"
                              class="align-end"
                              height="200px"
                            />
                          </div>
                       </v-card>
                       <v-card v-else>
                            <img src="" alt="Image Preview" style="max-width: 200px; max-height: 200px;" />
                          </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-checkbox v-model="isCCTVInstalled">
                       <template v-slot:label>
                          <span>15.Is CCTV Installed and is Working?</span><span class="error--text ml-1">*</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                  </v-col>
                </v-row>
              </div>
               </v-card-text>

            </v-card>
            <v-card>
              <div>
                <!-- <img :src="" alt="Image Preview" style="max-width: 200px; max-height: 200px;" /> -->
              </div>
            </v-card>
            <v-spacer></v-spacer>
              </v-container>
              <v-container
              class="read-only-container container--fluid"
              >
                <v-card class="cardviewborder"
                v-for="(driver, index) in formData.drivers" :key="index"
                >
               <v-toolbar flat>
                  <v-toolbar-title class="text-h6">{{ `Section C.${index + 1}. Driver ${index + 1}` }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon @click="handleRemoveDriverCard(index, driver.driverID)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn> -->
               </v-toolbar>
               <v-card-text>
                <div class="mt-2">
                <!-- <v-chip>Bus - {{ index + 1 }}</v-chip> -->
                <v-row>
                  <v-col>
                    <v-row>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">1.Driver Name</span>
                        <span class="error--text ml-1">*</span>:
                        <v-text-field v-model.trim="driver.driverName" required class="my-0 py-1" ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">2.Driver Mobile No.</span>
                        <span class="error--text ml-1">*</span>:
                        <v-text-field v-model="driver.driverMobileNumber" required class="my-0 py-1" type="tel" maxlength="10"  placeholder="Enter 10-digit mobile number">
                          <!-- <template v-slot:append>
                            <v-btn
                              icon
                              color="primary"
                              @click="verifyMobileNo"
                            >
                            verify
                            </v-btn>
                          </template> -->
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">3.Driver License No.</span>
                        <span class="error--text ml-1">*</span>:
                        <v-text-field v-model.trim="driver.driverLicenseNumber" required class="my-0 py-1" ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-row>
                      <v-col cols="12" lg="4" sm="6">
                        <span class="body-2 font-weight-medium">4.Unique Identification No.</span>
                        <span class="error--text ml-1">*</span>:
                        <v-text-field v-model.trim="driver.uniqueIdentificationNumber" required class="my-0 py-1" ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" sm="6" class="custompointer">
                        <span class="body-2 font-weight-medium">5.License Expiry Date<span class="error--text ml-1">*</span>:
                          <v-tooltip  v-if="driver.licenseExpiryDetails.isExpired"
                           bottom color="#E65050"
                           >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="ml-5" v-bind="attrs" v-on="on" color="red">mdi-information</v-icon>
                              </template>
                              <span class="red-tooltip">{{ driver.licenseExpiryDetails.sentence }}</span>
                          </v-tooltip>
                        </span>
                        <custom-date-picker  v-model="driver.licenceExpiryDate" @input="handleValidateExpiryDate($event, 'License', 'drivers', 'licenceExpiryDate',index)"/>
                      </v-col>

                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <p>Uploaded Documents:</p>
                    <v-row
                    v-if="driver.driverID"
                    >
                      <v-col v-for="(document,index) in driver.transportVendorDriversDocuments" :key="document.driverDocumentID" cols="12" sm="6" md="4">
                         <v-card class="relative-position allviewpadd" v-if="document && document.urlPath">
                            <h4>{{ `${index + 6}.${photoFieldNames[document.photoField] || formatCamelCase(document.photoField)}`}}<span class="error--text ml-1">*</span>:</label></h4>
                            <div
                              @click="handleImageClick(document)"
                              style="cursor: pointer; height: 200px; display: flex; align-items: center; justify-content: center;"
                              >
                              <v-img
                                :src="document.urlPath"
                                class="align-end"
                                height="200px"
                              >
                              </v-img>
                             </div>

                          </v-card>
                          <v-card v-else>
                            <img src="" alt="Image Preview" style="max-width: 200px; max-height: 200px;" />
                          </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
               </v-card-text>
            </v-card>
            <v-card>
              <div>
                <!-- <img :src="" alt="Image Preview" style="max-width: 200px; max-height: 200px;" /> -->
              </div>
            </v-card>
            <v-spacer></v-spacer>
              </v-container>
              <v-container class="cardviewborderall container--fluid"
              >
                <v-card >
                    <v-data-table
                    :headers="headers"
                    :items="vendorLogsDetails"
                    item-key="id"
                    class="elevation-1 custom-table"
                    :items-per-page="-1"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.action }}</td>
                            <td>{{ formatData(item.section) }}</td>
                            <td>
                              <div v-for="(field, index) in item.field.split(',')" :key="index">
                                {{ formatString(field.trim()) }}
                              </div>
                            </td>
                            <td>{{ formatDate(item.updatedAt) }}</td>
                            <td>{{ formatTime(item.updatedAt) }}</td>
                            <td>{{ item.createdBy }}</td>
                            <td>
                              <router-link  v-if="item.oldData" :to="{ name: 'VendorLogDetails', params: { logID: item.dataID }, query: { dataID:item.id, logType: 'old' }}">
                                Version
                              </router-link>
                              <span v-else class="router-link-disabled">
                                -
                              </span>
                            </td>
                            <td>
                              <router-link  v-if="item.newData" :to="{ name: 'VendorLogDetails', params: { logID: item.dataID }, query: { dataID:item.id, logType: 'new' } }">
                                Version
                              </router-link>
                              <span v-else class="router-link-disabled">
                                -
                              </span>
                            </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-card>
              </v-container>
            </v-card-component>
          </div>
        </form>
      </section>
    </div>
  </template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import CustomDatePicker from '@/components/template/CustomDatePickerr'
import Utils from '@/utils'
import moment from 'moment'

export default {
  name: 'VendorViewOnly',
  props: ['vendorID'],
  computed: {
    cardTitle () {
      if (this.vendorName) {
        return `View- ${this.vendorName} -Vendor/Vendor Details`
      }
      return 'View- Vendor/Vendor Details'
    }
  },
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      vendorName: null,
      isVendorActivated: null,
      isMobileNoVerified: false,
      total: 0,
      dropFile: [],
      franchiseeID: '',
      vtsActivation: 1,
      batteryNo: '',
      MakeOfvehicle: '',
      RCBookNo: '',
      RCExpirydate: '',
      RCStartdate: '',
      ChasisNo: '',
      engineNumber: '',
      rentCost: 0,
      MakeOfthevehicle: '',
      seatingCapacity: '',
      Purchasedate: '',
      ModelOfvehicle: '',
      registrationNo: '',
      franchiseeArr: [],
      isRequired: false,
      vehicleType: 'School Owned',
      selectedFranchisee: [],
      academicYears: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      vtsactivations: [{ id: 1, name: 'YES' }],
      VehicleTypes: [
        { id: 1, name: 'School Owned', value: 'School-Owned' },
        { id: 2, name: 'Leased Vehicle', value: 'School-Leased' },
        { id: 3, name: 'Vendor Owned', value: 'Vendor-Owned' }
      ],
      headers: [
        { text: 'Action Taken', value: 'action' },
        { text: 'Section', value: 'section' },
        { text: 'Field', value: 'field' },
        { text: 'Date', value: 'updatedAt' },
        { text: 'Time', value: 'time' },
        { text: 'Updated By', value: 'createdBy' },
        { text: 'Old Data', value: 'oldData.id' },
        { text: 'New Data', value: 'newData.id' }
      ],
      vendorLogsDetails: [],
      data: [
        {
          id: 1,
          actionTaken: 'Updated record',
          section: 'Personal Info',
          field: 'Email',
          date: '2024-08-20',
          time: '14:35',
          updatedBy: 'John Doe',
          oldData: 'john.doe@oldmail.com',
          newData: 'john.doe@example.com'
        },
        {
          id: 2,
          actionTaken: 'Deleted record',
          section: 'Account Settings',
          field: 'Phone Number',
          date: '2024-08-21',
          time: '09:12',
          updatedBy: 'Jane Smith',
          oldData: '555-555-1234',
          newData: 'N/A'
        },
        {
          id: 3,
          actionTaken: 'Created record',
          section: 'Preferences',
          field: 'Notification Settings',
          date: '2024-08-22',
          time: '11:50',
          updatedBy: 'Alice Johnson',
          oldData: 'None',
          newData: 'Enabled'
        }
      ],
      allowedFiles: ['png', 'jpg', 'jpeg', 'pdf'],
      isCCTVInstalled: true,
      formData: {
        franchiseeID: null,
        ownedBy: null,
        ownerName: null,
        ownersMobileNumber: null,
        numberOfVehicle: 0,
        numberOfDrivers: 0,
        updatedAt: null,
        deletedBusIDs: [],
        deletedDriverIDs: [],
        buses: [],
        drivers: []
      },
      deletedBusDocumentIds: [],
      deletedDriverDocumentIds: [],
      fileFields: [
        { field: 'rcBookFrontPhoto', label: '7.RC Card Front' },
        { field: 'rcBookBackPhoto', label: '8.RC Card Back' },
        { field: 'pucFrontPhoto', label: '9.PUC Front View' },
        { field: 'vehicleFrontViewPhoto', label: '10.Vehicle Front View' },
        { field: 'vehicleRearViewPhoto', label: '11.Vehicle Rear View' },
        { field: 'vehicleInteriorViewPhoto', label: '12.Vehicle Interior View' },
        { field: 'vehicleInteriorLeftViewPhoto', label: '13.Vehicle Interior Left View' },
        { field: 'vehicleInteriorRightViewPhoto', label: '14.Vehicle Interior Right View' }
      ],
      driverfileFields: [
        { field: 'driverLicenseFrontPhoto', label: '6.Driver License Front' },
        { field: 'driverPhoto', label: '7.Driver Photo' },
        { field: 'driverPoliceVerificationPhoto', label: '8.Driver Police Verification Photo' }
      ],
      fileKeys: ['rcBookFrontPhoto', 'rcBookBackPhoto', 'pucFrontPhoto', 'vehicleFrontViewPhoto', 'vehicleRearViewPhoto', 'vehicleInteriorViewPhoto', 'vehicleInteriorLeftViewPhoto', 'vehicleInteriorRightViewPhoto', 'driverLicenseFrontPhoto', 'driverPhoto', 'driverPoliceVerificationPhoto'],
      documentFileKeys: {
        vehicle: ['rcBookFrontPhoto', 'rcBookBackPhoto', 'pucFrontPhoto', 'vehicleFrontViewPhoto', 'vehicleRearViewPhoto', 'vehicleInteriorViewPhoto', 'vehicleInteriorLeftViewPhoto', 'vehicleInteriorRightViewPhoto'],
        driver: ['driverLicenseFrontPhoto', 'driverPhoto', 'driverPoliceVerificationPhoto']
      },
      photoFieldNames: {
        rcBookFrontPhoto: 'RC Card Front',
        rcBookBackPhoto: 'RC Card Back',
        pucFrontPhoto: 'PUC Front View',
        vehicleFrontViewPhoto: 'Vehicle Front View',
        vehicleRearViewPhoto: 'Vehicle Rear View',
        vehicleInteriorViewPhoto: 'Vehicle Interior View',
        vehicleInteriorLeftViewPhoto: 'Vehicle Interior Left View',
        vehicleInteriorRightViewPhoto: 'Vehicle Interior Right View',
        driverLicenseFrontPhoto: 'Driver License Front',
        driverPhoto: 'Driver Photo',
        driverPoliceVerificationPhoto: "Driver's Police Verification Photo"
      },
      vendorData: {}
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYear()
    await this.getVendorDetails()
    await this.getVendorLogsDetails()
  },
  watch: {
    'formData.numberOfVehicle': function (newVal, oldVal) {
      this.addBusForms()
    },
    'formData.numberOfDrivers': function (newVal, oldVal) {
      this.addDriverForms()
    }
  },
  methods: {
    formatData (value) {
      if (!value) {
        return '-'
      } else {
        return value
      }
    },
    formatString (input) {
      if (!input) {
        return '-'
      }
      const spaced = input.replace(/([A-Z])/g, ' $1').trim()
      const capitalized = spaced.replace(/\b\w/g, char => char.toUpperCase())
      return capitalized
    },
    handleImageClick (document) {
      window.open(document.urlPath, '_blank')
    },
    isDateInExpiry (dateString, type, key, isActive) {
      const today = moment().startOf('day')
      const docDate = moment(dateString, 'YYYY-MM-DD')
      const differenceInDays = docDate.diff(today, 'days')
      const autoDeactivationDate = docDate.clone().subtract(5, 'days')
      const differenceInDeactivationDays = differenceInDays - 5
      const within60Days = docDate.isBefore(today.clone().add(60, 'days'))

      let isExpired = false
      let sentence = ''

      if (within60Days) {
        // Future expiry
        if (differenceInDays > 0) {
          let diffIncludingEventDay = docDate.diff(today, 'days') + 1
          let diffDeactivationDay = diffIncludingEventDay - 5

          if (diffDeactivationDay <= 0) {
            sentence = `${type} expiring in ${Math.abs(diffIncludingEventDay)} days.`
            sentence += isActive
              ? (isActive && diffDeactivationDay === 0
                ? `The ${key} will be deactivated today.`
                : `The ${key} will be deactivated.`)
              : `The ${key} is already deactivated.`
          } else if (diffDeactivationDay === 1) {
            sentence = `${type} expiring in ${Math.abs(diffIncludingEventDay)} days.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated in 1 day.`
              : ` The ${key} is already deactivated.`
          } else if (diffIncludingEventDay === 1) {
            sentence = `${type} expiring in 1 day.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated tomorrow.`
              : ` The ${key} was auto deactivated ${Math.abs(diffDeactivationDay)} days ago.`
          } else if (diffIncludingEventDay === 5) {
            sentence = `${type} expiring in 5 days.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated in 5 days.`
              : ` The ${key} was auto deactivated ${Math.abs(diffDeactivationDay)} days ago.`
          } else if (diffIncludingEventDay < 5) {
            sentence = `${type} expiring in ${Math.abs(diffIncludingEventDay)} days.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated in ${Math.abs(diffDeactivationDay)} days.`
              : ` The ${key} was auto deactivated ${Math.abs(diffDeactivationDay)} days ago.`
          } else {
            sentence = `${type} expiring in ${diffIncludingEventDay} days.`
            sentence += isActive
              ? `The ${key} will be auto deactivated in ${Math.abs(diffDeactivationDay)} days.`
              : `The ${key} is already deactivated.`
          }
        } else if (differenceInDays === 0) {
          if (docDate.isSame(today.clone().add(1, 'days'), 'day')) {
            // If the date is tomorrow
            sentence = `${type} expiring in 1 day.`
            sentence += isActive
              ? ` The ${key} will be auto deactivated soon.`
              : ` The ${key} is already deactivated.`
          } else {
            // If the date is today
            if (today.isSame(autoDeactivationDate, 'day')) {
              sentence = `${type} expiring today.`
              sentence += isActive
                ? ` The ${key} will be auto deactivated today.`
                : ` The ${key} is already deactivated.`
            } else {
              sentence = `${type} expired today.`
              sentence += isActive
                ? ` The ${key} will be auto deactivated soon.`
                : ` The ${key} was auto deactivated ${Math.abs(today.diff(autoDeactivationDate, 'days'))} days ago.`
            }
          }
        } else {
          const expiredDaysAgo = Math.abs(differenceInDays)
          if (expiredDaysAgo === 1) {
            sentence = `${type} expired ${expiredDaysAgo} day ago. The ${key} was auto deactivated 6 days ago.`
          } else if (expiredDaysAgo === 5) {
            sentence = `${type} expired ${expiredDaysAgo} days ago. The ${key} was auto deactivated 10 days ago.`
          } else {
            sentence = `${type} expired ${expiredDaysAgo} days ago. The ${key} was auto deactivated ${expiredDaysAgo + 5} days ago.`
          }
        }
        isExpired = true
      }
      return {
        isExpired,
        differenceInDays,
        differenceInDeactivationDays,
        sentence
      }
    },
    formatCamelCase (str) {
      return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
        .toUpperCase()
        .replace(/^./, (match) => match.toUpperCase())
    },
    handleClickLogVersion (dataID) {

    },
    getBusFields () {
      return {
        vehicleRegistrationNumber: '',
        seatingCapacity: '',
        makeOfVehicle: '',
        modelOfVehicle: '',
        rcBookExpiryDate: '',
        pucExpiryDate: '',
        rcBookFrontPhoto: null,
        rcBookBackPhoto: null,
        pucFrontPhoto: null,
        vehicleFrontViewPhoto: null,
        vehicleRearViewPhoto: null,
        vehicleInteriorViewPhoto: null,
        vehicleInteriorLeftViewPhoto: null,
        vehicleInteriorRightViewPhoto: null,
        rcBookFrontPhotoUrl: null,
        rcBookBackPhotoUrl: null,
        pucFrontPhotoUrl: null,
        vehicleFrontViewPhotoUrl: null,
        vehicleRearViewPhotoUrl: null,
        vehicleInteriorViewPhotoUrl: null,
        vehicleInteriorLeftViewPhotoUrl: null,
        vehicleInteriorRightViewPhotoUrl: null
      }
    },
    formatVehicleNumber (input) {
      let formatted = input.replace(/[^A-Za-z0-9]/g, '')

      if (formatted.length >= 2) formatted = formatted.slice(0, 2) + '-' + formatted.slice(2)
      if (formatted.length >= 5) formatted = formatted.slice(0, 5) + '-' + formatted.slice(5)
      if (formatted.length >= 8) formatted = formatted.slice(0, 8) + '-' + formatted.slice(8)

      return formatted.toUpperCase()
    },
    handleVehicleNumberInput (event, index) {
      const input = event
      const formattedInput = this.formatVehicleNumber(input)
      this.formData.buses[index].vehicleRegistrationNumber = formattedInput
    },
    getDriverFields () {
      return {
        driverName: '',
        driverMobileNumber: '',
        driverLicenseNumber: '',
        uniqueIdentificationNumber: '',
        licenceExpiryDate: '',
        driverLicenseFrontPhoto: null,
        driverPhoto: null,
        driverPoliceVerificationPhoto: null,
        driverLicenseFrontPhotoUrl: null,
        driverPhotoUrl: null,
        driverPoliceVerificationPhotoUrl: null
      }
    },
    addBusForms () {
      const busesCount = this.formData.numberOfVehicle
      if (busesCount < 1) {
        this.errMsg('Atleast 1 Vehicle should present')
        return
      }
      const newBuses = []
      for (let i = 0; i < busesCount; i++) {
        let bus = this.formData.buses[i]

        let busData = bus || this.getBusFields()
        newBuses.push(busData)
      }
      this.formData.buses = newBuses
    },
    addDriverForms () {
      const driverCount = this.formData.numberOfDrivers
      if (driverCount < 1) {
        this.errMsg('Atleast 1 Driver should present')
        return
      }
      const newDrivers = []
      for (let i = 0; i < driverCount; i++) {
        let driver = this.formData.drivers[i]
        let driverData = driver || this.getDriverFields()
        newDrivers.push(driverData)
      }
      this.formData.drivers = newDrivers
    },
    increaseDriversCount () {
      let driverCount = Number(this.formData.numberOfDrivers)
      this.formData.numberOfDrivers = driverCount + 1
    },
    increaseVehicleCount () {
      let vehicleCount = Number(this.formData.numberOfVehicle)
      this.formData.numberOfVehicle = vehicleCount + 1
    },
    handleRemoveVehicleCard (index, busID) {
      let vehicleCount = Number(this.formData.numberOfVehicle)
      if (vehicleCount === 1) {
        this.errMsg('Atleast 1 vehicle should present')
        return
      }
      if (busID) {
        this.formData.deletedBusIDs.push(busID)
      }
      this.formData.buses.splice(index, 1)
      this.formData.numberOfVehicle = vehicleCount - 1
    },
    handleRemoveDriverCard (index, driverID) {
      let driversCount = Number(this.formData.numberOfDrivers)
      if (driversCount === 1) {
        this.errMsg('Atleast 1 Driver should present')
        return
      }
      if (driverID) {
        this.formData.deletedDriverIDs.push(driverID)
      }
      this.formData.drivers.splice(index, 1)
      this.formData.numberOfDrivers = driversCount - 1
    },
    verifyMobileNo () {
      this.isMobileNoVerified = true
    },
    handleValidateExpiryDate (event, key, type, fieldName, index) {
      let todayDate = this.getTodayDate()
      let inputDate = event
      let diff = new Date(inputDate) - new Date(todayDate)
      let diffInDays = diff / (1000 * 60 * 60 * 24)
      if (diffInDays < 60) {
        this.errMsg(`The vehicle cannot be added, as the ${key} is expiring in 60 days. Please add vehicle with valid ${key}`)
        this.$set(this.formData[type][index], fieldName, null)
      }
    },
    getDateAfterNDays (date, n) {
      return moment(date).add(20, 'd').format('YYYY-MM-DD')
    },
    getTodayDate () {
      return moment().format('YYYY-MM-DD')
    },
    getVendorDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vendors/${this.vendorID}`)
        this.isVendorActivated = data.isActive
        this.vendorName = data.ownerName
        this.formData.franchiseeID = data.franchisee.franchiseeID
        this.formData.ownersMobileNumber = data.ownersMobileNumber
        this.formData.ownerName = data.ownerName
        this.formData.numberOfDrivers = Number(data.numberOfDrivers)
        this.formData.numberOfVehicle = Number(data.numberOfBuses)
        this.formData.ownedBy = data.ownedBy
        this.formData.updatedAt = moment(data.updatedAt).format('DD/MM/YYYY')
        this.formData.buses = data.transportVendorBuses.map(item => {
          const expiryDetails = this.isDateInExpiry(item.rcBookExpiryDate, 'RC', 'Bus/Van', item.isActive)
          return {
            ...item,
            rcExpiryDetails: expiryDetails
          }
        })
        this.formData.drivers = data.transportVendorDrivers.map(item => {
          const expiryDetails = this.isDateInExpiry(item.licenceExpiryDate, 'License', 'Driver', item.isActive)
          return {
            ...item,
            licenseExpiryDetails: expiryDetails
          }
        })
        const photoFieldOrder = [
          'driverLicenseFrontPhoto',
          'driverPhoto',
          'driverPoliceVerificationPhoto'
        ]

        const vehicleDocumentSequence = [
          'rcBookFrontPhoto',
          'rcBookBackPhoto',
          'pucFrontPhoto',
          'vehicleFrontViewPhoto',
          'vehicleRearViewPhoto',
          'vehicleInteriorViewPhoto',
          'vehicleInteriorLeftViewPhoto',
          'vehicleInteriorRightViewPhoto'
        ]

        this.formData.buses.forEach(bus => {
          bus.transportVendorBusesDocuments.sort((a, b) => {
            return vehicleDocumentSequence.indexOf(a.photoField) - vehicleDocumentSequence.indexOf(b.photoField)
          })
        })
        this.formData.drivers.forEach(driver => {
          driver.transportVendorDriversDocuments.sort((a, b) => {
            return photoFieldOrder.indexOf(a.photoField) - photoFieldOrder.indexOf(b.photoField)
          })
        })

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        this.$router.push({ name: 'Vendor' })
      }
    },
    getVendorLogsDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vendors/${this.vendorID}/logs`)
        this.vendorLogsDetails = data
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.snackbar.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 5000,
          position: 'is-bottom-right',
          actionText: 'Close'
        })
        // this.$router.push({ name: 'Vendor' })
      }
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`
        )
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        // const errorMessage =
        //   (e && e.response && e.response.data.message) || e.message
      }
    },
    deleteDropFile (data, key) {
      this.$set(data, key, null)
      let urlKey = key.replace('Photo', 'PhotoUrl')
      this.$set(data, urlKey, null)
    },
    deleteDocument (data, id, userType) {
      if (userType === 'bus') {
        this.deletedBusDocumentIds.push(id)
        let busDocumentIndex = data.transportVendorBusesDocuments.findIndex(item => item.busDocumentID === id)
        data.transportVendorBusesDocuments[busDocumentIndex].urlPath = null
      }
      if (userType === 'driver') {
        this.deletedDriverDocumentIds.push(id)
        let driverDocumentIndex = data.transportVendorDriversDocuments.findIndex(item => item.driverDocumentID === id)
        data.transportVendorDriversDocuments[driverDocumentIndex].urlPath = null
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        if (!this.validateForm()) {
          this.errMsg('Please Fill Mandatory Details')
          return
        }
        this.loadingComponent = this.$buefy.loading.open()
        let payload = { ...this.formData }
        payload.buses = payload.buses.map((bus, index) => {
          const updatedBus = {
            ...bus,
            busSequenceNumber: index + 1
          }
          for (let key in updatedBus) {
            if (key.includes('Photo')) {
              delete updatedBus[key]
            }
            if (key.includes('PhotoUrl')) {
              delete updatedBus[key]
            }
            if (key.includes('transportVendorBusesDocuments')) {
              delete updatedBus[key]
            }
          }

          return updatedBus
        })
        payload.drivers = payload.drivers.map((driver, index) => {
          const updatedDriver = {
            ...driver,
            driverSequenceNumber: index + 1
          }
          for (let key in updatedDriver) {
            if (key.includes('Photo')) {
              delete updatedDriver[key]
            }
            if (key.includes('PhotoUrl')) {
              delete updatedDriver[key]
            }
            if (key.includes('transportVendorDriversDocuments')) {
              delete updatedDriver[key]
            }
          }

          return updatedDriver
        })
        this.hasClicked = true

        const docFormData = new FormData()

        docFormData.append('transportVendorID', this.vendorID)
        // '202bbefe-2323-4abe-894d-b1830f6b8ecf'
        docFormData.append('numberOfBuses', Number(payload.numberOfVehicle))

        let isNewDocumentSelected = false

        this.formData.buses.forEach((bus, index) => {
          for (let field of this.fileFields) {
            if (bus[field.field]) {
              isNewDocumentSelected = true
              docFormData.append(`docFormData_${field.field}_${index + 1}`, bus[field.field])
            }
          }
        })
        this.formData.drivers.forEach((driver, index) => {
          for (let field of this.driverfileFields) {
            if (driver[field.field]) {
              isNewDocumentSelected = true
              docFormData.append(`docFormData_${field.field}_${index + 1}`, driver[field.field])
            }
          }
        })

        let response = await http.post(
          `${constants.API_URL}/api/transport/vendors/${this.vendorID}/edit`,
          payload
        )
        let busMetaData = response.data.data.buses
        let driverMetaData = response.data.data.drivers

        docFormData.append('busMetaData', JSON.stringify(busMetaData))
        docFormData.append('driverMetaData', JSON.stringify(driverMetaData))
        docFormData.append('deletedBusDocumentIds', JSON.stringify(this.deletedBusDocumentIds))
        docFormData.append('deletedDriverDocumentIds', JSON.stringify(this.deletedDriverDocumentIds))
        if (isNewDocumentSelected) {
          await http.post(
            `${constants.API_URL}/api/transport/vendors/update-documents`,
            docFormData
          )
        }

        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'Vendor' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Vendor updated successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    validVendorDetails () {
      if (!this.formData.franchiseeID ||
            !this.formData.ownedBy ||
            !this.formData.ownerName ||
            !this.formData.ownersMobileNumber ||
            !this.formData.numberOfVehicle ||
            !this.formData.numberOfDrivers
      ) {
        return false
      }
      this.isVendorDetailsPresent = true
      return true
    },
    validVehicleDetails () {
      let buscount = this.formData.buses.length
      if (buscount === 0) {
        return false
      }
      let vehicleKeyFields = Object.keys(this.getBusFields())
      vehicleKeyFields = vehicleKeyFields.filter(key => !key.includes('PhotoUrl'))

      for (let i = 0; i < buscount; i++) {
        let vehicle = this.formData.buses[i]
        for (let key of vehicleKeyFields) {
          if (vehicle.transportVendorBusesDocuments) {
            if (
              (!key.includes('Photo') && !vehicle[key]) ||
              (key.includes('Photo') &&
                (!vehicle.transportVendorBusesDocuments.find(item => item.photoField === key).urlPath && !vehicle[key]))) {
              return false
            }
          } else {
            if (!vehicle[key]) {
              return false
            }
          }
        }
      }
      if (!this.isCCTVInstalled) {
        return false
      }
      this.isVehicleDetailsPresent = true
      return true
    },
    validDriverDetails () {
      let driversCount = this.formData.drivers.length
      let driverFieldKeys = Object.keys(this.getDriverFields())
      driverFieldKeys = driverFieldKeys.filter(key => !key.includes('PhotoUrl'))
      for (let i = 0; i < driversCount; i++) {
        let driver = this.formData.drivers[i]
        for (let key of driverFieldKeys) {
          if (key.includes('PhotoUrl')) {
            delete driverFieldKeys[key]
          }
        }
        for (let key of driverFieldKeys) {
          if (driver.transportVendorDriversDocuments) {
            if ((!key.includes('Photo') && !driver[key]) || (key.includes('Photo') && (!driver.transportVendorDriversDocuments.find(item => item.photoField === key).urlPath && !driver[key]))) {
              return false
            }
          } else {
            if (!driver[key]) {
              return false
            }
          }
        }
      }
      return true
    },
    validateForm () {
      if (!this.validVendorDetails()) {
        return false
      }
      if (!this.validVehicleDetails()) {
        return false
      }
      if (!this.validDriverDetails()) {
        return false
      }
      if (!this.areUniqueBusInputs()) {
        return false
      }

      return true
    },
    areUniqueBusInputs () {
      let s = new Set()
      for (let bus of this.formData.buses) {
        let veh = bus.vehicleRegistrationNumber.toLowerCase().split('').filter(i => i !== ' ').join('')
        if (s.has(veh)) {
          return false
        }
        s.add(veh)
      }
      return true
    },
    onFileChange (bus, key, filetype, index) {
      const file = event.target.files[0]
      this.$set(bus, key, file)
      let urlKey = `${key}Url`
      let url = URL.createObjectURL(file)
      this.$set(bus, urlKey, url)
    },
    clear () {
      if (this.vehicleType !== 'School Owned') {
        this.isRequired = true
        this.rentCost = ''
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    draftBusDetails (index) {
      this.focusedBus = null
      this.clearDraft()

      localStorage.setItem('vendorDraft', JSON.stringify(this.formData))
      this.$dialog.message.info(`Bus - ${index + 1} Drafted successfully!`, {
        position: 'bottom-right',
        color: 'secondary',
        timeout: 4000
      })
    },
    clearDraft () {
      localStorage.removeItem('vendorDraft')
    },
    isBusFormAllFilled (index) {
      let isAllFilled = true
      let bus = this.formData.buses[index]
      for (let key in bus) {
        if (!key.includes('Photo') &&
            !bus[key] &&
            !['isFormDrafted', 'shouldDraftButtonDisable', 'isBusFocused'].includes(key)
        ) {
          isAllFilled = false
          bus.shouldDraftButtonDisable = false
          break
        }
      }
      return isAllFilled
    },
    formatDate (createdDate) {
      const date = new Date(createdDate)
      return date.toLocaleDateString()
    },
    formatTime (createdTime) {
      const time = new Date(createdTime)
      return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
    }
  }
}
</script>

  <style scoped>
.read-only-container .v-tooltip,
.read-only-container .v-tooltip .v-icon,
.read-only-container .red-tooltip {
  pointer-events: auto;
  background-color: '#E65050';
   color: '#fff',
}

  .imagevvendowviewupload{
    width:100%
  }
  .imagevvendowviewupload img{
    max-width: 100%;
  }
  .imagevvenderdownload-buttom{
    padding-top: 8px;
    width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
  }
  .imagevvenderdownload-buttom button{
    font-size: 18px!important;
      width: 22px;
      height: 22px;
      display: inline-block;
      margin: 0px!important;
  }
  .imagevvenderdownload-buttom .image_dis{
       overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 150px;
  }

  .custom-table {
  table-layout: auto;
}

.custom-table td {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
  </style>

  <style>
   .custompointer .v-input__control {
  pointer-events: none;
  opacity: 0.9;
  position: relative;
  }
  .read-only-container .v-input__control{
    pointer-events: none;
  opacity: 0.9;
  position: relative;
  }
  .read-only-container{
    padding: 0px;
    margin-bottom: 15px;
  }
  .container.read-only-container .cardviewborder{
    box-shadow: none;
    border: 1px solid #ccc;
  }
  .container.cardviewborderall{
   padding: 0px;
  }
  .container.cardviewborderall .v-card{
    box-shadow: none;
  }
  .allviewpadd{
    padding: 15px !important;
  }

</style>
